import { scriptJson } from "../formats/script-json";

export const REQUIRED_PUBLIC_CONFIG_KEYS = [
  "NEXT_PUBLIC_APP_URL",
  "NEXT_PUBLIC_CONVEX_URL",
  "NEXT_PUBLIC_STRIPE_PUBLISHABLE_KEY",
  "NEXT_PUBLIC_WORKOS_REDIRECT_URI",
] as const;

export const OPTIONAL_PUBLIC_CONFIG_KEYS = [
  "NEXT_PUBLIC_CONVEX_SITE_URL",
  "NEXT_PUBLIC_GOOGLE_MAPS_API_KEY",
  "NEXT_PUBLIC_MAPBOX_TOKEN",
  "NEXT_PUBLIC_MAP_TILES_URL",
  "NEXT_PUBLIC_POSTHOG_HOST",
  "NEXT_PUBLIC_POSTHOG_KEY",
  "NEXT_PUBLIC_POSTHOG_TOKEN",
  "NEXT_PUBLIC_POSTHOG_UI_HOST",
  "NEXT_PUBLIC_STRIPE_DASHBOARD_BASE_URL",
  "NEXT_PUBLIC_WEBMCP_TOOLS",
] as const;

export const PUBLIC_ENVIRONMENT_KEY = "NEXT_PUBLIC_ENVIRONMENT";

export const PUBLIC_CONFIG_KEYS = [
  ...REQUIRED_PUBLIC_CONFIG_KEYS,
  ...OPTIONAL_PUBLIC_CONFIG_KEYS,
  PUBLIC_ENVIRONMENT_KEY,
] as const;

export type PublicConfigKey = (typeof PUBLIC_CONFIG_KEYS)[number];

export type PublicConfig = Partial<Record<PublicConfigKey, string>>;

export const PUBLIC_CONFIG_ELEMENT_ID = "repackify-public-config";

function isPublicConfigKey(key: string): key is PublicConfigKey {
  return PUBLIC_CONFIG_KEYS.some((allowed) => allowed === key);
}

export function pickPublicConfig(read: (key: PublicConfigKey) => string | undefined): PublicConfig {
  const config: PublicConfig = {};
  for (const key of PUBLIC_CONFIG_KEYS) {
    const value = read(key)?.trim();
    if (value) config[key] = value;
  }
  return config;
}

export function serializePublicConfig(config: PublicConfig): string {
  return scriptJson(pickPublicConfig((key) => config[key]));
}

export function parsePublicConfig(text: string): PublicConfig {
  const parsed: unknown = JSON.parse(text);
  if (typeof parsed !== "object" || parsed === null || Array.isArray(parsed)) return {};
  const config: PublicConfig = {};
  for (const [key, value] of Object.entries(parsed)) {
    if (isPublicConfigKey(key) && typeof value === "string") config[key] = value;
  }
  return config;
}
